import { FC } from 'react';
import { Button } from 'antd';
import { keycloak } from 'shared/api';
import styles from './SuspendedPage.module.scss';

export const SuspendedPage: FC = () => {
  const handleLogout = () => {
    // Полный разлогин в Keycloak
    keycloak.logout();
  };

  return (
    <div className={styles.suspendedPage}>
      <div className={styles.content}>
        <h1 className={styles.title}>
          Доступ заблокирован
        </h1>
        <p className={styles.description}>
          Ваш доступ заблокирован. Обратитесь к администратору для получения дополнительной информации.
        </p>
        <Button
          type="primary"
          danger
          size="large"
          onClick={handleLogout}
        >
          Выйти
        </Button>
      </div>
    </div>
  );
};
